<div class="post-tab">
  <div class="post-tab__text-area">
    <textarea
      class="post-tab__textarea"
      placeholder="Type your message... "
      [formControl]="form().controls.text"
      cdkTextareaAutosize
      [cdkAutosizeMinRows]="1"
      [cdkAutosizeMaxRows]="3"
    ></textarea>
  </div>

  @if (state.images().length > 0 || state.uploadingCount() > 0) {
    <outlaw-image-grid
      [images]="state.images()"
      [uploadingCount]="state.uploadingCount()"
      (imageRemoved)="onImageRemoved($event)"
      (imagesReordered)="onImagesReordered($event)"
    />
  }

  @if (state.showLinkInput()) {
    <div class="post-tab__link-fields">
      <outlaw-floating-input [control]="form().controls.linkTitle" label="Button title" />
      <outlaw-floating-input [control]="form().controls.linkUrl" label="Button link" type="url" (enterPressed)="confirmLink()">
        <outlaw-field-error [control]="form().controls.linkUrl" />
      </outlaw-floating-input>
    </div>
  }

  @if (state.links().length > 0) {
    <div class="post-tab__links-list">
      @for (link of state.links(); track $index; let i = $index) {
        <div class="post-tab__link-chip">
          <span class="post-tab__link-chip-text">{{ link.link_url }}</span>
          <button class="post-tab__link-chip-remove" aria-label="Remove link" (click)="removeLink(i)">
            <outlaw-icon name="close" [size]="10" />
          </button>
        </div>
      }
    </div>
  }

  <input
    #fileInput
    type="file"
    accept="image/*"
    multiple
    hidden
    (change)="onFileSelected($event)"
  />

  <div class="post-tab__toolbar">
    <div class="post-tab__toolbar-left">
      <button class="post-tab__icon-btn" [class.active]="state.images().length > 0" (click)="onAddMedia()">
        <outlaw-icon name="media" [size]="26" />
      </button>
      <button class="post-tab__icon-btn" [class.active]="state.showLinkInput() || state.links().length > 0" (click)="onAddLink()">
        <outlaw-icon name="link" [size]="26" />
      </button>
    </div>
    <div class="post-tab__toolbar-right">
      <outlaw-selections-menu
        [selections]="state.allSelections()"
        postUuid="__pending__"
        mode="inline"
        (selectionToggled)="state.toggleSelection($event)"
        (createClicked)="state.openCreateSelection()"
      >
        <button
          class="post-tab__icon-btn"
          [class.active]="state.selectedSelections().length > 0"
        >
          <outlaw-icon name="grid" [size]="26" />
        </button>
      </outlaw-selections-menu>
      <button
        class="community-button primary with-line"
        [disabled]="!canPublish()"
        (click)="publishRequested.emit()"
      >
        Publish
      </button>
    </div>
  </div>
</div>
